import React from "react";
import ReactDOM from "react-dom";
// import Handlebars from "handlebars";
const { data } = require('./About.data');

import "./AboutUs.scss";

// const htmlContent = require("./About.html");
import htmlContent from './AboutUs.hbs';// works as template fn

// const template = Handlebars.compile(htmlContent);// fails

const About = (props) => {

  const {
    // data
  } = props;

  const h_cont = htmlContent(data);

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: h_cont }} className={`hbs_comp plax-bg`} />
      {/* <div dangerouslySetInnerHTML={{ __html: template(data) }} /> */}
    </>
  );
}

export default About
